// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as ModalBody from "../../../../library/reuseable-components/ModalBody.bs.js";
import * as Belt_Array from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as SlabsTable from "../../../sidebars/SlabsTable.bs.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ErrorBanner from "../common/ErrorBanner.bs.js";
import * as ModalFooter from "../../../../library/reuseable-components/ModalFooter.bs.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingUtils from "../../../../library/utils/CorePricingUtils.bs.js";
import * as CorePricingContext from "../../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as AccordionV2$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionV2.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as CorePricingViewUtils from "../../../../library/utils/CorePricingViewUtils.bs.js";
import * as ModificationStatusVm from "../../../../vm-mapper/ModificationStatusVm.bs.js";
import * as ModificationsContext from "../../../../library/modifications-context/ModificationsContext.bs.js";
import * as ModificationPreviewVm from "../../../../vm-mapper/modification-preview/ModificationPreviewVm.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as VehicleGeoRegionTitleBar from "../../../sidebars/core-pricing/VehicleGeoRegionTitleBar.bs.js";
import * as TooltipComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/tooltip/TooltipComponent.bs.js";
import * as ModificationBaseDetailsCard from "../../modification-details/ModificationBaseDetailsCard.bs.js";
import * as PricingDashboardDataMachine from "../../../../../../app/PricingDashboardDataMachine.bs.js";
import * as ModicationPreviewStateMachine from "./ModicationPreviewStateMachine.bs.js";
import * as CreateModificationEntityEncoder from "../common/CreateModificationEntityEncoder.bs.js";
import * as CreateModificationConfirmationModal from "../common/CreateModificationConfirmationModal.bs.js";

function testIdsToString(test_gr_customer_ids) {
  return " ( id: " + String(test_gr_customer_ids.start) + " - " + String(test_gr_customer_ids.end) + " )";
}

function ModificationPreview$AccordionHeaderForTestSample(Props) {
  var test_gr_customer_ids = Props.test_gr_customer_ids;
  var index = Props.index;
  return React.createElement("div", undefined, "Test " + String(index + 1 | 0) + testIdsToString(test_gr_customer_ids));
}

var AccordionHeaderForTestSample = {
  testIdsToString: testIdsToString,
  make: ModificationPreview$AccordionHeaderForTestSample
};

function getAbBaseDetailsAccordionPanels(base_details) {
  var base_detail_cmp_list = Belt_List.fromArray(Belt_Array.mapWithIndex(base_details, (function (index, test_detail) {
              if (test_detail.TAG !== /* AB */0) {
                return ErrorUtils$Catalyst.raiseError("AbModificationPreview.res", "invalid type", "");
              }
              var test_gr_customer_ids = test_detail.test_gr_customer_ids;
              return AccordionTypes$Catalyst.make_props({
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement(ModificationPreview$AccordionHeaderForTestSample, {
                                          test_gr_customer_ids: test_gr_customer_ids,
                                          index: index
                                        });
                            })
                        }, undefined, undefined, React.createElement(ModificationBaseDetailsCard.make, {
                              base_details: test_detail.test_details
                            }), undefined);
            })));
  var match = Belt_Array.getExn(base_details, 0);
  var tmp;
  tmp = match.TAG === /* AB */0 ? AccordionTypes$Catalyst.make_props({
          TAG: /* Text */0,
          _0: "Control"
        }, undefined, undefined, React.createElement(ModificationBaseDetailsCard.make, {
              base_details: match.control_details
            }), undefined) : ErrorUtils$Catalyst.raiseError("AbModificationPreview.res", "invalid type", "");
  return Belt_List.concat(base_detail_cmp_list, {
              hd: tmp,
              tl: /* [] */0
            });
}

function ModificationPreview$BaseDetailsSection(Props) {
  var base_details = Props.base_details;
  var base_detail = Belt_Array.getExn(base_details, 0);
  var tmp;
  if (base_detail.TAG === /* AB */0) {
    tmp = React.createElement(AccordionV2$Catalyst.make, {
          panels: getAbBaseDetailsAccordionPanels(base_details),
          defaultOpen: 0
        });
  } else {
    var base_details$1 = Belt_Array.getExn(base_details, 0);
    var tmp$1;
    tmp$1 = base_details$1.TAG === /* AB */0 ? ErrorUtils$Catalyst.raiseError("AbModificationPreview.res", "invalid type", "") : base_details$1._0;
    tmp = React.createElement(ModificationBaseDetailsCard.make, {
          base_details: tmp$1
        });
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "card-title"
                }, "BASE DETAILS"), tmp);
}

var BaseDetailsSection = {
  getAbBaseDetailsAccordionPanels: getAbBaseDetailsAccordionPanels,
  make: ModificationPreview$BaseDetailsSection
};

function getAbSlabDetailsAccordionPanels(slabs) {
  var slab_detail_cmp_list = Belt_List.fromArray(Belt_Array.mapWithIndex(slabs, (function (index, slab) {
              if (slab.TAG !== /* AB */0) {
                return ErrorUtils$Catalyst.raiseError("AbModificationPreview.res", "invalid type", "");
              }
              var test_gr_customer_ids = slab.test_gr_customer_ids;
              return AccordionTypes$Catalyst.make_props({
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement(ModificationPreview$AccordionHeaderForTestSample, {
                                          test_gr_customer_ids: test_gr_customer_ids,
                                          index: index
                                        });
                            })
                        }, undefined, undefined, React.createElement(CardComponent$Catalyst.make, {
                              className: "modification-basic-primary-info-card",
                              children: React.createElement(SlabsTable.make, {
                                    slabs: slab.test_details
                                  })
                            }), undefined);
            })));
  var match = Belt_Array.getExn(slabs, 0);
  var tmp;
  tmp = match.TAG === /* AB */0 ? AccordionTypes$Catalyst.make_props({
          TAG: /* Text */0,
          _0: "Control"
        }, undefined, undefined, React.createElement(CardComponent$Catalyst.make, {
              className: "modification-basic-primary-info-card",
              children: React.createElement(SlabsTable.make, {
                    slabs: match.control_details
                  })
            }), undefined) : ErrorUtils$Catalyst.raiseError("AbModificationPreview.res", "invalid type", "");
  return Belt_List.concat(slab_detail_cmp_list, {
              hd: tmp,
              tl: /* [] */0
            });
}

function ModificationPreview$SlabDetailsSection(Props) {
  var slabs = Props.slabs;
  var slab_detail = Belt_Array.getExn(slabs, 0);
  var tmp;
  if (slab_detail.TAG === /* AB */0) {
    tmp = React.createElement(AccordionV2$Catalyst.make, {
          panels: getAbSlabDetailsAccordionPanels(slabs),
          defaultOpen: 0
        });
  } else {
    var slab_details = Belt_Array.getExn(slabs, 0);
    var tmp$1;
    tmp$1 = slab_details.TAG === /* AB */0 ? ErrorUtils$Catalyst.raiseError("AbModificationPreview.res", "invalid type", "") : slab_details._0;
    tmp = React.createElement(CardComponent$Catalyst.make, {
          className: "modification-basic-primary-info-card",
          children: React.createElement(SlabsTable.make, {
                slabs: tmp$1
              })
        });
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "card-title"
                }, "SLAB DETAILS"), tmp);
}

var SlabDetailsSection = {
  getAbSlabDetailsAccordionPanels: getAbSlabDetailsAccordionPanels,
  make: ModificationPreview$SlabDetailsSection
};

function ModificationPreview$EligibilityRulesCard$ClusterAndZoneDescription(Props) {
  var info = Props.info;
  var tool_tip = info.tool_tip_content;
  if (tool_tip !== undefined) {
    return React.createElement("div", {
                className: "cluster-zone-tool-tip"
              }, React.createElement("div", undefined, info.content), React.createElement(TooltipComponent$Catalyst.make, {
                    content: tool_tip.content,
                    placement: /* Top_End */10,
                    children: React.createElement("div", {
                          className: "popper"
                        }, tool_tip.title)
                  }));
  } else {
    return React.createElement("div", undefined, info.content);
  }
}

var ClusterAndZoneDescription = {
  make: ModificationPreview$EligibilityRulesCard$ClusterAndZoneDescription
};

function ModificationPreview$EligibilityRulesCard(Props) {
  var eligibility_rules = Props.eligibility_rules;
  return React.createElement(CardComponent$Catalyst.make, {
              className: "modification-basic-primary-info-card",
              children: null
            }, React.createElement(CorePricingViewUtils.LineItem.make, {
                  label: "Start Time",
                  unit: "hh:mm",
                  value: Timestamp$Catalyst.toString(eligibility_rules.start_time, "HH:mm")
                }), React.createElement(CorePricingViewUtils.LineItem.make, {
                  label: "End Time",
                  unit: "hh:mm",
                  value: Timestamp$Catalyst.toString(eligibility_rules.end_time, "HH:mm")
                }), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(CorePricingViewUtils.LineItem.make, {
                  label: "Repeat On Day(s)",
                  value: eligibility_rules.repeat_days
                }), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Pickup Cluster(s)"), React.createElement(ModificationPreview$EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.pick_up_cluster
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Pickup Zone(s)"), React.createElement(ModificationPreview$EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.pick_up_zone
                    })), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Drop Cluster(s)"), React.createElement(ModificationPreview$EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.drop_cluster
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Drop Zone(s)"), React.createElement(ModificationPreview$EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.drop_zone
                    })));
}

var EligibilityRulesCard = {
  ClusterAndZoneDescription: ClusterAndZoneDescription,
  make: ModificationPreview$EligibilityRulesCard
};

function ModificationPreview(Props) {
  var modification_form_data = Props.modification_form_data;
  var core_pricing = Props.core_pricing;
  var close_create_modal = Props.close_create_modal;
  var onBack = Props.onBack;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var iso_code = CountryConfig.getIsoCode(country);
  var match$1 = CorePricingContext.useContext(undefined);
  var match$2 = React.useReducer(ModicationPreviewStateMachine.reducer, /* Init */0);
  var dispatch = match$2[1];
  var create_modification_state = match$2[0];
  var match$3 = CorePricingContext.useContext(undefined);
  var openSnackbar = match$3.openSnackbar;
  var match$4 = ModificationsContext.useContext(undefined);
  var openPendingPrioritiesTab = match$4.openPendingPrioritiesTab;
  var refetchModifications = match$4.refetchModifications;
  var match$5 = React.useState(function () {
        return false;
      });
  var toggleConfirmationModal = match$5[1];
  modification_form_data.TAG === /* AB */0;
  var modification = ModificationPreviewVm.getVm(modification_form_data, core_pricing, CorePricingUtils.getNameFromRole(match$1.role), match$4.zones, match$4.clusters);
  var end_date = modification.end_date;
  return React.createElement(React.Fragment, undefined, typeof create_modification_state === "number" ? null : React.createElement(ErrorBanner.make, {
                    error: create_modification_state._0
                  }), React.createElement(ModalBody.make, {
                  className: "c-modification-preview-content",
                  children: null
                }, React.createElement(VehicleGeoRegionTitleBar.make, {
                      vehicle_name: modification.vehicle_name,
                      geo_region: modification.region
                    }), React.createElement(CardComponent$Catalyst.make, {
                      className: "modification-basic-primary-info-card",
                      children: null
                    }, React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, "Status"), React.createElement("div", {
                              className: ModificationStatusVm.toString(modification.status)
                            }, ModificationStatusVm.toString(modification.status))), React.createElement(CorePricingViewUtils.LineItem.make, {
                          label: "Created By",
                          value: modification.created_by
                        }), React.createElement(CorePricingViewUtils.LineItem.make, {
                          label: "Created On",
                          value: modification.created_on
                        })), React.createElement(CardComponent$Catalyst.make, {
                      className: "modification-basic-primary-info-card",
                      children: null
                    }, React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, "Parent Core Campaign"), React.createElement("div", {
                              className: ""
                            }, modification.core_pricing_name)), React.createElement(CorePricingViewUtils.LineItem.make, {
                          label: "Start Date",
                          unit: "dd/mm/yyyy",
                          value: Timestamp$Catalyst.toString(modification.start_date, "DD/MM/yyyy")
                        }), end_date !== undefined ? React.createElement(CorePricingViewUtils.LineItem.make, {
                            label: "End Date",
                            unit: "dd/mm/yyyy",
                            value: Timestamp$Catalyst.toString(Caml_option.valFromOption(end_date), "DD/MM/yyyy")
                          }) : null), React.createElement(ModificationPreview$BaseDetailsSection, {
                      base_details: modification.base_details
                    }), React.createElement(ModificationPreview$SlabDetailsSection, {
                      slabs: modification.slabs
                    }), React.createElement(ModificationPreview$EligibilityRulesCard, {
                      eligibility_rules: modification.eligibility_rules
                    })), React.createElement(CreateModificationConfirmationModal.make, {
                  isOpen: match$5[0],
                  modification_name: modification.name,
                  campaign_name: core_pricing.campaign_name,
                  onConfirmCb: (function (param) {
                      var payload = CreateModificationEntityEncoder.execute(modification_form_data, core_pricing.campaign_id);
                      PricingDashboardDataMachine.createModification(payload, iso_code, (function (param) {
                              Curry._1(refetchModifications, undefined);
                              Curry._1(openPendingPrioritiesTab, undefined);
                              Curry._1(close_create_modal, undefined);
                              return Curry._1(openSnackbar, {
                                          TAG: /* Success */0,
                                          _0: modification.name + " Modification has been successfully created and sent for approval"
                                        });
                            }), (function (err) {
                              return Curry._1(dispatch, /* SetError */{
                                          _0: err
                                        });
                            }), country);
                      Curry._1(toggleConfirmationModal, (function (param) {
                              return false;
                            }));
                      return Curry._1(dispatch, /* SetSubmitting */0);
                    }),
                  onCancelCb: (function (param) {
                      return Curry._1(toggleConfirmationModal, (function (param) {
                                    return false;
                                  }));
                    })
                }), React.createElement(ModalFooter.make, {
                  children: null
                }, React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Previous"
                          }, undefined, (function (param) {
                              return Curry._1(onBack, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn " + (
                            create_modification_state === /* Submitting */1 ? "e-disabled-btn" : ""
                          ), undefined, undefined)
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Submit"
                          }, undefined, (function (param) {
                              return Curry._1(toggleConfirmationModal, (function (param) {
                                            return true;
                                          }));
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn " + (
                            create_modification_state === /* Submitting */1 ? "e-disabled-btn" : ""
                          ), undefined, undefined)
                    })));
}

var make = ModificationPreview;

export {
  AccordionHeaderForTestSample ,
  BaseDetailsSection ,
  SlabDetailsSection ,
  EligibilityRulesCard ,
  make ,
  
}
/* react Not a pure module */
